import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Input(props) {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  let {
    label,
    placeholder,
    value,
    type,
    name,
    autoComplete,
    onChange,
    customStyle,
    defaultValue,
    disabled,
    customLabel,
    isError,
  } = props;
  const inputType = type === "password" && showPassword ? "text" : type;

  return (
    <div className="w-full relative">
      <label
        className={`${`mb-2 mt-6 ${customLabel} block capitalize tracking-wide text-[#292929] text-[15px] font-semibold `}`}
        htmlFor="grid-last-name"
      >
        {label}
      </label>
      <input
        className={`${customStyle} appearance-none block  pr-10 w-full border-[#737373] text-[#292929] border  rounded py-3 px-4 focus:outline-none focus:bg-white  ${
          isError
            ? "focus:border-red-500 border-red-500 "
            : "focus:border-gray-500"
        }`}
        id={type}
        type={inputType}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={onChange}
        readOnly={props.readOnly}
        name={name}
        defaultValue={defaultValue}
        disabled={disabled}
      />
      {type === "password" && (
        <div
          className="absolute inset-y-0  right-2 top-[44%] flex items-center cursor-pointer"
          onClick={toggleShowPassword}
        >
          {showPassword ? <FaEyeSlash size={25} /> : <FaEye size={25} />}
        </div>
      )}
    </div>
  );
}

export default Input;
